import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentUtilsService } from '@core/services';
import {
  biometricValidationMethod,
  customComponentListener,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { VUOnboardingFaceComponent } from '@shared/components/vu-onboarding/face/face.component';


@Component({
  imports: [TranslateModule, VUOnboardingFaceComponent],
  standalone: true,
  selector: 'biometric-capture-face-component',
  templateUrl: './capture-face.component.html',
  styleUrls: ['./capture-face.component.scss'],
})
export class CustomBiometricCaptureFaceComponent {
  @Input({ required: false }) listeners!: customComponentListener[];

  @Output() onBiometricFingerprintCaptured = new EventEmitter<{
    method: biometricValidationMethod;
  }>();

  protected selectedValidationMethod?: biometricValidationMethod = undefined;

  constructor(private utils: ComponentUtilsService) {}

  ngOnInit() {
    this.utils.attachListeners(this, this.listeners);
  }
}
